import { DYNAMIC_CONFIG_NAMES, getConfig } from '@/lib/statsig';
import { Countries } from '@/types/Countries';

const getThreeTierProductsConfig = (countryCode: Countries) => {
  return getConfig(DYNAMIC_CONFIG_NAMES.threeTierPricingProductsConfig, {
    custom: {
      country: countryCode,
    },
  });
};

export const isThreeTierProduct = (
  countryCode: Countries,
  productCode: string
) => {
  const config = getThreeTierProductsConfig(countryCode);

  return config?.get<string[]>('products', []).includes(productCode);
};
